import ReactDOM from 'react-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import CountrySelect from './CountrySelect';
import RegionSelect from './RegionSelect';
import ax, { REGISTER, VERIFY_RECAPTCHA } from '%/axios';
import ReCAPTCHA from "react-google-recaptcha";
import { useRef, useState } from 'react';
import toast from '%/toast';
import ToastContainer from '../features/dashboard/components/ToastContainer';

const schema = yup.object().shape({
  email: yup.string().email().required('Email is a required field'),
  password: yup.string().required('Please enter your password')
    .min(8, 'Must be atleast 8 characters'),
  confirm_password: yup.string().required('Confirm password is a required field'),
  country: yup.string().required('Country is a required field'),
  city: yup.string().required('City is a required field'),
  state: yup.string().required('State is a required field'),
  fname: yup.string().required('First name is a required field'),
  lname: yup.string().required('Last name is a required field'),
  address_1: yup.string().required('Address is a required field'),
  address_2: yup.string(),
  zip: yup.string().required('Zip is a required field'),
  phone: yup.string(/^\+?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4,6}$/, 'Invalid phone number or format').matches().required('Phone number is a required field'),
  company_name: yup.string(),
  am_customer_code: yup.string()

});

const RegisterForm = (props) => {

  const {
    redirect = '/'
  } = props;
  const recapRef = useRef();
  const [verified, setVerified] = useState(false);


  const submitForm = async (data, form) => {
    if(!verified) return;
    try {
      const res = await ax(REGISTER, data);
      if (res) {
        toast('Register successful');

        window.location.href = redirect;
      }
    } catch (er) {
      console.error(er);
      if (/Account with this email/i.test(er.message)) {
        toast.error(er.message);
      }
    }
  }
  const verifyToken = async (token) => {
    // return true;
    try {
      // console.log(recapRef.current.getResponse());
      const res = await ax(VERIFY_RECAPTCHA, { token });
      recapRef.current = !!res.success;
      if (res.success)
        setVerified(true);
      return res?.success;
    } catch (er) {
      conso.trace(er);
      throw new Error();

    }
  }

  return (
    <Formik
      validationSchema={schema}
      initialValues={{
        email: '',
        password: '',
        confirm_password: '',
        country: 'United States',
        city: '',
        state: '',
        fname: '',
        lname: '',
        address_1: '',
        zip: '',
        phone: '',
        company_name: '',
        am_customer_code: ''
      }}
      onSubmit={submitForm}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
        const fieldError = (name) => touched[name] && errors[name]
          ? <p className='form-error-message'>{errors[name]}</p>
          : null;
        const inputClass = (base, name) =>
          base + (touched[name] && errors[name] ? ' input-invalid' : '');

        return (
          <form className='form login-form' onSubmit={handleSubmit}>

            <div className='form-field half'>
              <div style={{ flex: 1 }}>
                <input
                  value={values.fname}
                  className={inputClass('form-input', 'fname')}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name='fname'
                  placeholder='First Name*'
                />
                {fieldError('fname')}
              </div>
              <div style={{ flex: 1 }}>
                <input
                  value={values.lname}
                  className={inputClass('form-input', 'lname')}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='Last Name*'
                  name='lname'
                />
                {fieldError('lname')}
              </div>
            </div>

            <div className='form-field'>
              <CountrySelect
                handleChange={handleChange}
                value={values.country}
              />
            </div>

            <div className='form-field'>
              <input
                className={inputClass('form-input', 'address_1')}
                name='address_1'
                placeholder='Address Line 1*'
                value={values.address_1}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {fieldError('address_1')}
            </div>

            <div className='form-field'>
              <input
                className='form-input'
                name='address_2'
                placeholder='Address Line 2'
                value={values.address_2}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>

            <div className='form-field'>
              <input
                className={inputClass('form-input', 'city')}
                name='city'
                placeholder='Suburb/City*'
                value={values.city}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {fieldError('city')}
            </div>

            <div className='form-field'>
              <RegionSelect
                handleChange={handleChange}
                value={values.state}
                country={values.country}
              />
              {fieldError('state')}
            </div>

            <div className='form-field'>
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                className={inputClass('form-input', 'zip')}
                value={values.zip}
                placeholder='Zip/Postcode*'
                name='zip'
              />
              {fieldError('zip')}
            </div>

            <div className='form-field'>
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                className={inputClass('form-input', 'phone')}
                value={values.phone}
                placeholder='Phone Number*'
                name='phone'
              />
              {fieldError('phone')}
            </div>

            <div className='form-field'>
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                className='form-input'
                value={values.company}
                placeholder='Agency or Company Name'
                name='company'
              />
            </div>

            <div className='form-field'>
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                className={inputClass('login-text-field w-input', 'email')}
                value={values.email}
                placeholder='Email*'
                name='email'
              />
              {fieldError('email')}
            </div>

            <div className='form-field'>
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                className={inputClass('login-text-field w-input', 'password')}
                value={values.password}
                placeholder='Password*'
                type='password'
                name='password'
              />
              {fieldError('password')}
            </div>

            <div className='form-field'>
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                className={inputClass('login-text-field w-input', 'confirm_password')}
                value={values.confirm_password}
                placeholder='Confirm Password*'
                type='password'
                name='confirm_password'
              />
              {fieldError('confirm_password')}
            </div>

            <div style={{ marginBottom: 12 }}>
              <ReCAPTCHA
                sitekey="6LfUY8clAAAAAEJBofevY7k63tePIyIea0cHFd6h"
                onChange={verifyToken}
              />
            </div>

            <button
              type='submit'
              onClick={handleSubmit}
              className='yellow-king-form-button w-button'
            >Submit</button>

          </form>
        );
      }}
    </Formik>
  )

}

export default RegisterForm;

if (document.getElementById('react--register-form'))
  ReactDOM.render(
    <><RegisterForm /><ToastContainer /></>,
    document.getElementById('react--register-form')
  )